
import Vue from 'vue';
import Component from 'vue-class-component';
@Component
export default class About extends Vue {
  title() {
    return 'ご案内';
  }
}
